import type { GridColDef } from '@mui/x-data-grid-pro';

export const DASH_PLACEHOLDER = '—';

export const isMissingValue = (value: any): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') return value.trim() === '';
  return false;
};

export const formatMissingValue = (value: any, fallback: string = DASH_PLACEHOLDER): any => {
  return isMissingValue(value) ? fallback : value;
};

export const formatMissingText = (value: any, fallback: string = DASH_PLACEHOLDER): string => {
  return String(formatMissingValue(value, fallback));
};

const NO_DASH_FIELDS = new Set(['actions', 'action', 'Action', '__check__', '__expand__']);

export const applyDashValueFormatter = (columns: GridColDef[]): GridColDef[] => {
  return columns.map((column) => {
    if (column.type === 'actions' || NO_DASH_FIELDS.has(String(column.field ?? ''))) {
      return column;
    }

    const existingValueFormatter = column.valueFormatter as any;

    return {
      ...column,
      valueFormatter: (...args: any[]) => {
        const rawValue = args?.[0] && typeof args[0] === 'object' && 'value' in args[0]
          ? args[0].value
          : args?.[0];
        const formatted = existingValueFormatter ? existingValueFormatter(...args) : rawValue;
        return formatMissingText(formatted);
      },
    };
  });
};
